/**
 * REVIVE OUTFIT - Product Interest Badge Controller
 * Manages Real Viewers, Demo Preview simulation, and Neutral messages
 */

class ReviveInterestBadge extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
  }

  connectedCallback() {
    this.mode = this.dataset.mode || 'demo';
    this.min = parseInt(this.dataset.min, 10) || 12;
    this.max = parseInt(this.dataset.max, 10) || 28;
    this.interval = (parseInt(this.dataset.interval, 10) || 5) * 1000;
    this.badgeText = this.dataset.badgeText || 'people are viewing this piece right now';
    this.neutralText = this.dataset.neutralText || 'Trending now — high interest item';

    this.countEl = this.querySelector('[data-rib-count]');
    this.contentEl = this.querySelector('[data-rib-content]');

    if (this.mode === 'demo') {
      this.currentCount = Math.floor((this.min + this.max) / 2);
      this.startDemoSimulation();
    } else if (this.mode === 'real') {
      this.checkRealViewers();
    }
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  startDemoSimulation() {
    if (this.timer) clearInterval(this.timer);

    this.timer = setInterval(() => {
      // Gentle fluctuation (+/- 1 to 3) within boundaries
      const delta = (Math.random() > 0.5 ? 1 : -1) * (Math.floor(Math.random() * 3) + 1);
      this.currentCount = Math.max(this.min, Math.min(this.max, this.currentCount + delta));

      if (this.countEl) {
        this.countEl.textContent = this.currentCount;
      }
    }, this.interval);
  }

  checkRealViewers() {
    // Check if an authorized external service or window global is present
    if (window.__REVIVE_LIVE_VIEWERS__ && typeof window.__REVIVE_LIVE_VIEWERS__.getCount === 'function') {
      const realCount = window.__REVIVE_LIVE_VIEWERS__.getCount();
      if (typeof realCount === 'number' && realCount > 0) {
        if (this.contentEl) {
          this.contentEl.innerHTML = `<strong>${realCount}</strong> ${this.badgeText}`;
        }
        return;
      }
    }

    // Honest fallback: when no genuine tracking service exists, display neutral text
    if (this.contentEl) {
      this.contentEl.textContent = this.neutralText;
    }
  }
}

if (!customElements.get('revive-interest-badge')) {
  customElements.define('revive-interest-badge', ReviveInterestBadge);
}
